import REPORT from "./Report";

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/ContactListQualityAssurance/components/index.js